module.exports = __webpack_public_path__ + "img/zixun1@2x.b8773733.png";